/**
 * Wavelength Hub Client SDK - Main Entry Point
 * @module WavelengthHub
 */

import { TenantAPI } from './tenant.js';
import { ThemeAPI } from './theme.js';
import { ContentAPI } from './content.js';
import { ChatAPI } from './chat.js';
import { StateAPI } from './state.js';

/**
 * Main WavelengthHub SDK object
 * Provides access to all Hub APIs
 */
class WavelengthHubSDK {
  constructor() {
    this.tenant = new TenantAPI();
    this.theme = new ThemeAPI();
    this.content = new ContentAPI();
    this.chat = new ChatAPI();
    this.state = new StateAPI();
    
    console.log('[WavelengthHub SDK] v0.2.0 initialized');
  }

  /**
   * Get SDK version
   * @returns {string} SDK version
   */
  getVersion() {
    return '0.2.0';
  }

  /**
   * Check if all required APIs are available
   * @param {string[]} requiredAPIs - Array of required API names
   * @returns {boolean} True if all APIs are available
   */
  checkAvailability(requiredAPIs = []) {
    const availableAPIs = {
      tenant: this.tenant,
      theme: this.theme,
      content: this.content,
      chat: this.chat,
      state: this.state
    };

    return requiredAPIs.every(api => availableAPIs[api] !== undefined);
  }
}

// Create and export singleton instance
const WavelengthHub = new WavelengthHubSDK();

// Make available globally for browser usage
if (typeof window !== 'undefined') {
  window.WavelengthHub = WavelengthHub;
  console.log('[Hub API Bridge] Initialized');
}

export default WavelengthHub;
